module.exports = __webpack_public_path__ + "img/Birte-Schmidt-v2-740.e5c575fb.jpg";